import moment from "moment";
import app from '../main.js'
//import { isArray } from "lodash";

/**
 * Formats a given date for human-readable display.
 *
 * @param {Date} inputDate - The input date to be formatted.
 * @param {boolean} exportTime - Whether to include the time part in the formatted output. Default is true.
 * @param {boolean} exportSeconds - Whether to include seconds in the time part. Default is false.
 * @param {boolean} exportMilliseconds - Whether to include milliseconds in the time part. Default is false.
 * @returns {string} The formatted date according to the specified options.
 */
export function formatDateForHumans(inputDate, exportTime = true, exportSeconds = false, exportMilliseconds = false)
{
  const locale = app.$i18n.locale;
  let dateFormat;

  switch (locale)
  {
    case 'es':
      dateFormat = 'MMMM D YYYY'      
      break;
    
    case 'fr':
      dateFormat = 'D MMMM YYYY'
      break;
  
    default:
      dateFormat = 'MMMM Do YYYY'
      break;
  }

  if(exportTime)
  {
    dateFormat = `${dateFormat} HH:mm`;
    
    if(exportSeconds)
    {
      dateFormat = `${dateFormat}:ss`;
    }
  }

  let response = moment(inputDate).locale(locale).format(dateFormat);

  if(exportSeconds && exportMilliseconds)
  {
    /**
     * Moment was rounding the milliseconds, beacuse that's not what we want, 
     * we will just take the millisecongs from the original inputdate 
     * and we will just place on the formatted response
     */
    const dateArray = inputDate.split('.');

    if(Array.isArray(dateArray) && dateArray.length === 2) {
      const milliseconds = dateArray[1];
      response = `${response}.${milliseconds}`;
    }
  }

  return response;
}

export function getAge(inputDate) 
{
  var today = new Date();
  var dob = new Date(inputDate);
  var age = today.getFullYear() - dob.getFullYear();
  var month = today.getMonth() - dob.getMonth();
  var day = today.getDate() - dob.getDate();

  if (month < 0 || (month === 0 && day < 0)) {
      age--;
  }

  return age;
}
